import Button from 'design-system/src/components/Button/Button';

type OtherRequestButtonProps = {
  setShowNewFollowupTaskModal: (show: boolean) => void;
};

export const OtherRequestButton = ({ setShowNewFollowupTaskModal }: OtherRequestButtonProps) => {
  return (
    <Button type="button" variant="linkDotted" size="sm" onClick={() => setShowNewFollowupTaskModal(true)}>
      Request support
    </Button>
  );
};
